import { render, staticRenderFns } from "./AdminPayerList.vue?vue&type=template&id=5003e162&scoped=true"
import script from "./AdminPayerList.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPayerList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AdminPayerList.vue?vue&type=style&index=0&id=5003e162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5003e162",
  null
  
)

export default component.exports